import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormGroup } from "reactstrap";
import CustomDropDown from "../../../Common/FormFields/CustomDropDown";
import userService from "../../../services/user.service";
import {
  addVideoScheduleInformation,
  resetVideoScheduleEventData,
} from "../../../Redux/Actions/VideoScheduleAction";
import AddPlaylistDialog from "../Popups/AddPlaylistDialog";
import CamelCaseString from "../../../Common/CamelCaseString";
import { addPlaylistData } from "../../../Redux/Actions/VideoScheduleAction";
const InSeason = ({ formik }) => {
  const schoolId = useSelector((state) => state.loggedInUser.school.id);
  const { uploadVideoWeek, uploadVideoEventType, playlistData } = useSelector(
    (state) => state.videoScheduleInformation
  );
  const [weekArray, setWeekArray] = useState([]);
  const [open, setOpen] = useState(false);
  const [pageState, setPageState] = useState({
    page: 0,
    size: 10,
    currentPageNumber: 0,
    totalPages: 0,
    schedules: "",
  });
  const [isWeekWithOpponent, setIsWeekWithOpponent] = useState(true);
  const dispatch = useDispatch();
  const videoScheduleInformation = useSelector(
    (state) => state?.videoScheduleInformation
  );
  useEffect(() => {
    addPlaylistData(dispatch, []);
    resetVideoScheduleEventData(dispatch, [
      "uploadVideoEventType",
      "uploadPlaylistName",
      "uploadVideoWeekName",
    ]);
    getAllWeeks(pageState.page, pageState.size);
  }, []);

  const getAllWeeks = (page, size) => {
    const arr = [];
    userService
      .getSchedules(schoolId, page, size)
      .then((res) => {
        const { schedules, totalPages, currentPageNumber } = res.data.data;
        if (currentPageNumber < totalPages) {
          setPageState((old) => ({
            ...old,
            page: page,
            totalPages: totalPages,
            schedules: schedules,
          }));
          schedules.map((item) => {
            let obj = {
              id: item.id,
              name: `${item.seasonWeek.title} - ${item.opponent.schoolName}`,
            };
            arr.push(obj);
          });
          setWeekArray((oldArray) => [...oldArray, ...arr]);
        } else {
          setIsWeekWithOpponent(false);
        }
      })
      .catch((err) => {
        alert(err);
      });
  };

  const eventTypeList = [
    {
      id: 1,
      name: "Game",
    },
    {
      id: 2,
      name: "Practice",
    },
    {
      id: 3,
      name: "Opponent Scout",
    },
  ];

  const updateScheduleInformation = (fieldName, value) => {
    addVideoScheduleInformation(dispatch, {
      fieldName,
      value,
    });
  };

  const handleWeekSelect = (value) => {
    const result = weekArray?.find((week) => {
      return week?.name === value;
    });
    updateScheduleInformation("uploadVideoWeek", result?.id);
  };

  const togglePlaylistDialog = (status) => {
    setOpen(status);
  };

  const getPlaylistName = (id) => {
    const saveLocation = pageState?.schedules?.filter(
      (ele) => ele?.id == uploadVideoWeek
    );
    const categoryId = eventTypeList?.filter(
      (ele) => ele?.name == (id ? id : uploadVideoEventType)
    )[0]?.id;
    const seasonId = saveLocation[0]?.season?.id;
    const scheduleId = saveLocation[0]?.id;
    userService
      .getPlaylistName({
        scheduleId,
        seasonId,
        categoryId,
        schoolId,
        seasonType: "In-Season",
        isPractice: false,
      })
      .then((res) => {
        addPlaylistData(dispatch, []);
        const playlist = res.data.data.content.map((ele) => {
          return { id: ele.id, playlistName: ele.playlistName };
        });
        addPlaylistData(dispatch, playlist);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const createPlaylist = (playlistName) => {
    const saveLocation = pageState.schedules.filter(
      (ele) => ele.id == uploadVideoWeek
    );
    const categoryId = eventTypeList.filter(
      (ele) => ele.name == uploadVideoEventType
    )[0].id;
    const seasonId = saveLocation[0]?.season?.id;
    const scheduleId = saveLocation[0]?.id;
    userService
      .createPlaylist({
        schoolId,
        seasonId,
        scheduleId,
        playlistName,
        categoryId,
        seasonType: "In-Season",
        isPractice: false,
      })
      .then((res) => {
        getPlaylistName();
        togglePlaylistDialog(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <>
      <FormGroup>
        <label className="fmlabel mt-6 semi-bold">
          Week <span className="redstar">*</span>
        </label>
        <CustomDropDown
          selected={
            weekArray.length > 0
              ? videoScheduleInformation?.uploadVideoWeekName
              : "No Weeks Found"
          }
          setSelected={(value) => {
            resetVideoScheduleEventData(dispatch, [
              "uploadPlaylistName",
              "uploadVideoEventType",
            ]);
            addPlaylistData(dispatch, []);
            handleWeekSelect(value);
          }}
          formik={formik}
          fieldName="uploadVideoWeek"
          defaultSelectOption="Select Week"
          options={weekArray}
          fieldToShow="name"
          optionValue="id"
          isWeekWithOpponent={isWeekWithOpponent}
          isWeek={true}
          pageState={pageState}
          getWeekWithOpponent={getAllWeeks}
          setWeekValueAsWeekName={true}
        />
      </FormGroup>

      <FormGroup>
        <label className="fmlabel mt-6 semi-bold">
          Event Type <span className="redstar">*</span>
        </label>
        <CustomDropDown
          selected={videoScheduleInformation?.uploadVideoEventType}
          setSelected={(value) => {
            resetVideoScheduleEventData(dispatch, ["uploadPlaylistName"]);
            addPlaylistData(dispatch, []);
            updateScheduleInformation("uploadVideoEventType", value);
            getPlaylistName(value);
          }}
          formik={formik}
          fieldName="uploadVideoEventType"
          defaultSelectOption="Select Event Type"
          options={eventTypeList}
          fieldToShow="name"
          optionValue="name"
          disabledDropdown={
            videoScheduleInformation?.uploadVideoWeekName == "" ? true : false
          }
        />
      </FormGroup>

      <FormGroup>
        <label className="fmlabel mt-6 semi-bold">
          Playlist <span className="redstar">*</span>
        </label>
        <CustomDropDown
          selected={videoScheduleInformation?.uploadPlaylistName}
          setSelected={(value) =>
            updateScheduleInformation("uploadPlaylistName", value)
          }
          formik={formik}
          fieldName="playlistName"
          defaultSelectOption="Select Playlist"
          options={playlistData}
          fieldToShow="playlistName"
          optionValue="playlistName"
          isCreatePlaylist={true}
          setOpen={setOpen}
          disabledDropdown={
            videoScheduleInformation?.uploadVideoWeekName == "" ||
            videoScheduleInformation?.uploadVideoEventType == ""
              ? true
              : false
          }
        />
      </FormGroup>
      <AddPlaylistDialog
        successPopUp={open}
        msg="Playlist Name Popup"
        toggleSuccessDialog={togglePlaylistDialog}
        createPlaylist={createPlaylist}
      />
    </>
  );
};

export default InSeason;
